import { Grid, Typography } from "@mui/material";
import styled from "styled-components";

type SocialMediaLinkProps = {
  $iconSrc: string;
};

export const SocialMediaContainer = styled.div`
  width: 100%;
`;

export const SocialMediaItem = styled(Grid)`
  && {
    display: flex;
    justify-content: center;
    align-items: center;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`;

export const SocialMediaText = styled(Typography)`
  && {
    color: #ffffff;
    font-size: 1.2rem;
  }
`;

export const SocialMediaPhoneLink = styled.a`
  && {
    color: #ffffff;
    font-size: 1.2rem;
    text-decoration: none;
  }

  &&:hover {
    text-decoration: underline;
  }

  &&:focus-visible {
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }
`;

export const SocialMediaLink = styled.a<SocialMediaLinkProps>`
  display: block;
  background: url(${(props) => props.$iconSrc}) no-repeat center;
  background-size: 24px 24px;
  width: 100%;
  height: 36px;
  cursor: pointer;

  &:first-child {
    margin: 0;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    background-size: 24px 24px;
  }
`;